module.exports = __webpack_public_path__ + "img/image-4.b6fad608.png";